import type { TicketResponseData } from '@core/Areas/Account/Pages/Activity/types'
import { get } from '@core/Services/ApiService'

export const getAccountTransactions = ({
  nextPage,
  selectedDate,
}: {
  nextPage: string | null
  selectedDate?: string
}) => {
  const url = buildDataUrl({ nextPage, selectedDate })
  return get<TicketResponseData>({ url })
}

// =============
// Local Helpers
// =============

function buildDataUrl({
  nextPage,
  selectedDate,
}: {
  nextPage: string | null
  selectedDate?: string
}): string {
  const apiUrlBase = '/$_/accountActivity'

  const optionalHeadQuery = selectedDate ? `?selectedDate=${selectedDate}` : ''

  return !nextPage
    ? `${apiUrlBase}/tickets/transactions/head${optionalHeadQuery}`
    : apiUrlBase + nextPage
}
